import {
  deleteAdminV1StoresStoreIdPaymentsStripe,
  deleteAdminV1StoresStoreIdPaymentsStripeApplePayDomainsDomain,
  getAdminV1StoresStoreIdPaymentsStripe,
  getAdminV1StoresStoreIdPaymentsStripeApplePayDomains,
  postAdminV1StoresStoreIdPaymentsStripeApplePayDomains,
  postAdminV1StoresStoreIdPaymentsStripeConnect,
  postAdminV1StoresStoreIdPaymentsStripeConnectCallback,
  postAdminV1StoresStoreIdPaymentsStripeDirectKeys,
  putAdminV1StoresStoreIdPaymentsStripeWebhookSecret,
  type ApplePayDomainRequest,
  type ConnectStripeDirectKeysRequest,
  type StripeAccount,
  type StripeConnectCallbackRequest,
  type StripeConnectStart,
} from '@nucleus-commerce/api-client/admin';

/** The store's Stripe connection (Connect Standard, or the tenant's own keys as the exception). */
export const stripeApi = {
  get: (storeId: string): Promise<StripeAccount> =>
    getAdminV1StoresStoreIdPaymentsStripe({ storeId }),
  connect: (storeId: string): Promise<StripeConnectStart> =>
    postAdminV1StoresStoreIdPaymentsStripeConnect({ storeId }),
  completeConnect: (storeId: string, body: StripeConnectCallbackRequest): Promise<StripeAccount> =>
    postAdminV1StoresStoreIdPaymentsStripeConnectCallback({ storeId }, body),
  connectWithKeys: (
    storeId: string,
    body: ConnectStripeDirectKeysRequest,
  ): Promise<StripeAccount> => postAdminV1StoresStoreIdPaymentsStripeDirectKeys({ storeId }, body),
  disconnect: (storeId: string): Promise<void> =>
    deleteAdminV1StoresStoreIdPaymentsStripe({ storeId }),
  /** 422 PAYMENT_PROVIDER_REJECTED when Stripe cannot verify the domain association file. */
  addApplePayDomain: (storeId: string, body: ApplePayDomainRequest): Promise<StripeAccount> =>
    postAdminV1StoresStoreIdPaymentsStripeApplePayDomains({ storeId }, body),
  /** Empty while Stripe is not connected. */
  applePayDomains: (storeId: string): Promise<string[]> =>
    getAdminV1StoresStoreIdPaymentsStripeApplePayDomains({ storeId }).then((r) => r.items),
  removeApplePayDomain: (storeId: string, domain: string): Promise<void> =>
    deleteAdminV1StoresStoreIdPaymentsStripeApplePayDomainsDomain({ storeId, domain }),
  /** Direct-keys connections only; 409 CONFLICT on a Connect account. */
  setWebhookSecret: (storeId: string, secret: string): Promise<StripeAccount> =>
    putAdminV1StoresStoreIdPaymentsStripeWebhookSecret({ storeId }, { secret }),
};
